import * as Types from '../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const MedicineDictionaryItemByPublicIdDocument = `
    query MedicineDictionaryItemByPublicId($publicId: String!) {
  medicineDictionaryItemByPublicId(publicId: $publicId) {
    id
    publicId
    basicInfo {
      name
      simplifiedName
      pharmaceuticalEffectLiteracy
      medicineImage
      medicinePictogramImages
    }
    classificationInfo {
      ethicalType
    }
    companyInfo {
      companyName
    }
    ingredientInfo {
      formattedIngredientName
    }
    medicineGuide {
      interactionHtml
      indications
      dosages
      dosageHtml
      sideEffects
      cautions
      storages
      videoLink
    }
    packagingInfo {
      image
    }
  }
}
    `;
export const useMedicineDictionaryItemByPublicIdQuery = <
      TData = Types.MedicineDictionaryItemByPublicIdQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.MedicineDictionaryItemByPublicIdQueryVariables,
      options?: UseQueryOptions<Types.MedicineDictionaryItemByPublicIdQuery, TError, TData>,
    ) =>
    useQuery<Types.MedicineDictionaryItemByPublicIdQuery, TError, TData>(
      ['MedicineDictionaryItemByPublicId', variables],
      gqlFetcher<Types.MedicineDictionaryItemByPublicIdQuery, Types.MedicineDictionaryItemByPublicIdQueryVariables>(MedicineDictionaryItemByPublicIdDocument, 'MedicineDictionaryItemByPublicId', variables),
      options
    );

useMedicineDictionaryItemByPublicIdQuery.getKey = (variables: Types.MedicineDictionaryItemByPublicIdQueryVariables) => ['MedicineDictionaryItemByPublicId', variables];
;

useMedicineDictionaryItemByPublicIdQuery.fetcher = (variables: Types.MedicineDictionaryItemByPublicIdQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.MedicineDictionaryItemByPublicIdQuery, Types.MedicineDictionaryItemByPublicIdQueryVariables>(MedicineDictionaryItemByPublicIdDocument, 'MedicineDictionaryItemByPublicId', variables, options);
export const PopularMedicineDictionaryItemsDocument = `
    query PopularMedicineDictionaryItems {
  popularMedicineDictionaryItems {
    id
    publicId
    basicInfo {
      name
      simplifiedName
      pharmaceuticalEffectLiteracy
      medicineImage
    }
    medicineGuide {
      wholeSummary
    }
    packagingInfo {
      image
    }
  }
}
    `;
export const usePopularMedicineDictionaryItemsQuery = <
      TData = Types.PopularMedicineDictionaryItemsQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.PopularMedicineDictionaryItemsQueryVariables,
      options?: UseQueryOptions<Types.PopularMedicineDictionaryItemsQuery, TError, TData>,
    ) =>
    useQuery<Types.PopularMedicineDictionaryItemsQuery, TError, TData>(
      variables === undefined ? ['PopularMedicineDictionaryItems'] : ['PopularMedicineDictionaryItems', variables],
      gqlFetcher<Types.PopularMedicineDictionaryItemsQuery, Types.PopularMedicineDictionaryItemsQueryVariables>(PopularMedicineDictionaryItemsDocument, 'PopularMedicineDictionaryItems', variables),
      options
    );

usePopularMedicineDictionaryItemsQuery.getKey = (variables?: Types.PopularMedicineDictionaryItemsQueryVariables) => variables === undefined ? ['PopularMedicineDictionaryItems'] : ['PopularMedicineDictionaryItems', variables];
;

usePopularMedicineDictionaryItemsQuery.fetcher = (variables?: Types.PopularMedicineDictionaryItemsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.PopularMedicineDictionaryItemsQuery, Types.PopularMedicineDictionaryItemsQueryVariables>(PopularMedicineDictionaryItemsDocument, 'PopularMedicineDictionaryItems', variables, options);